export default __webpack_public_path__ + "static/media/Brown Circle.4b56eeaa.svg";